import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const content = {
  en: {
    title: 'Legal Notice',
    company: 'Company',
    companyType: 'A Florida Limited Liability Company',
    representedBy: 'Represented by',
    representedByValue: 'Julian Propst, Managing Member',
    address: 'Address',
    contact: 'Contact',
    registration: 'Registration',
    registrationValue: 'Registered with the Florida Department of State, Division of Corporations',
    liabilityContentTitle: 'Liability for Content',
    liabilityContent: 'The content of this website has been created with the utmost care. However, we cannot guarantee the accuracy, completeness, or timeliness of the content. As a service provider, we are responsible for our own content on these pages in accordance with general laws. However, we are not obligated to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information under general law remain unaffected.',
    liabilityLinksTitle: 'Liability for Links',
    liabilityLinks: 'Our website may contain links to external third-party websites over whose content we have no influence. Therefore, we cannot accept any liability for these external contents. The respective provider or operator of the linked pages is always responsible for their content. The linked pages were checked for possible legal violations at the time of linking. No illegal content was recognizable at the time of linking. Permanent content monitoring of the linked pages is not reasonable without concrete evidence of a legal violation.',
    copyrightTitle: 'Copyright',
    copyrightText: 'The content and works created by the site operators on these pages are subject to copyright. Reproduction, editing, distribution, and any kind of use beyond the limits of copyright law require the written consent of the respective author or creator.',
    jurisdictionTitle: 'Jurisdiction',
    jurisdictionText: 'This legal notice is governed by the laws of the State of Florida, United States. For any disputes arising in connection with this website, the courts of the State of Florida shall have jurisdiction.',
  },
  de: {
    title: 'Impressum',
    company: 'Unternehmen',
    companyType: 'Eine Gesellschaft mit beschränkter Haftung nach dem Recht des Staates Florida, USA',
    representedBy: 'Vertreten durch',
    representedByValue: 'Julian Propst, Geschäftsführender Gesellschafter (Managing Member)',
    address: 'Anschrift',
    contact: 'Kontakt',
    registration: 'Registrierung',
    registrationValue: 'Eingetragen beim Florida Department of State, Division of Corporations',
    liabilityContentTitle: 'Haftung für Inhalte',
    liabilityContent: 'Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.',
    liabilityLinksTitle: 'Haftung für Links',
    liabilityLinks: 'Unsere Website kann Links zu externen Websites Dritter enthalten, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.',
    copyrightTitle: 'Urheberrecht',
    copyrightText: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.',
    jurisdictionTitle: 'Gerichtsstand',
    jurisdictionText: 'Dieses Impressum unterliegt dem Recht des Staates Florida, Vereinigte Staaten von Amerika. Für Streitigkeiten im Zusammenhang mit dieser Website sind die Gerichte des Staates Florida zuständig.',
  },
}

function Imprint() {
  const isDe = useLocation().pathname.startsWith('/de')
  const homePath = isDe ? '/de' : '/'
  const t = isDe ? content.de : content.en

  return (
    <div>
      <div className="terms-of-use">
        <Link to={homePath}>
          <img style={{filter: 'invert(1)'}} src="./img/bonusclub_logo.webp" alt="BonusClub" />
        </Link>
        
        <h1>{t.title}</h1>
        {isDe && <p style={{fontSize: '12px', color: '#999', marginTop: '-10px'}}>Angaben gemäß § 5 DDG</p>}
        
        <section style={{padding: '40px 20px', fontSize: '14px', lineHeight: '1.6', color: '#666'}}>

          <p>
            <strong>{t.company}:</strong><br />
            BonusClub LLC<br />
            {t.companyType}
          </p>

          <p>
            <strong>{t.representedBy}:</strong><br />
            {t.representedByValue}
          </p>

          <p>
            <strong>{t.address}:</strong><br />
            7901 4th St N STE 300<br />
            St. Petersburg, FL 33702<br />
            United States
          </p>

          <p>
            <strong>{t.contact}:</strong><br />
            E-Mail: <a href="mailto:julian@bonusclub.io">julian@bonusclub.io</a><br />
            {isDe ? 'Telefon' : 'Phone'}: +1 (754) 276-0068
          </p>

          <p>
            <strong>{t.registration}:</strong><br />
            {t.registrationValue}<br />
            {isDe ? 'Dokument-Nr.' : 'Document No.'}: L25000513581
          </p>

          <h2 style={{fontSize: '16px', marginTop: '30px'}}>{t.liabilityContentTitle}</h2>
          <p>{t.liabilityContent}</p>

          <h2 style={{fontSize: '16px', marginTop: '30px'}}>{t.liabilityLinksTitle}</h2>
          <p>{t.liabilityLinks}</p>

          <h2 style={{fontSize: '16px', marginTop: '30px'}}>{t.copyrightTitle}</h2>
          <p>{t.copyrightText}</p>

          <h2 style={{fontSize: '16px', marginTop: '30px'}}>{t.jurisdictionTitle}</h2>
          <p>{t.jurisdictionText}</p>

          <p style={{marginTop: '30px', fontSize: '12px'}}>
            © {new Date().getFullYear()} BonusClub LLC. {isDe ? 'Alle Rechte vorbehalten.' : 'All rights reserved.'}
          </p>

        </section>
      </div>
    </div>
  )
}

export default Imprint
